import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/api";

export default function BatchPublicView({ batchNumber: propBatch }) {
  const params = useParams();
  const batchNumber = propBatch || params.batchNumber;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    if (!batchNumber) return;
    load();
  }, [batchNumber]);

  const load = async () => {
    try {
      setLoading(true);
         const decoded = decodeURIComponent(batchNumber);
         const res = await api.get(`/api/batch-records/secure/${decoded}`);
      setData(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light">
      <div className="spinner-grow text-success mb-3" role="status"></div>
      <div className="fw-bold text-muted">Verifying Product Authenticity...</div>
    </div>
  );

  if (!data) return (
    <div className="container py-5 text-center">
      <div className="alert alert-danger border-0 shadow-sm">Product information not found or invalid batch number.</div>
    </div>
  );

  return (
    <div className="min-vh-100 bg-light py-4 px-3 py-md-5">
      <div className="mx-auto" style={{ maxWidth: "600px" }}>
        
        {/* TOP BADGE */}
        <div className="text-center mb-4">
          <div className="d-inline-flex align-items-center bg-white border px-3 py-2 rounded-pill shadow-sm mb-3">
            <i className="bi bi-patch-check-fill text-success fs-5 me-2"></i>
            <span className="fw-bold small text-uppercase tracking-wider">Verified Product Record</span>
          </div>
          
        </div>

        {/* MAIN CERTIFICATE CARD */}
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4">
          <div className="bg-success py-2"></div>
          <div className="card-body p-4 p-md-5 bg-white">
            
            <div className="row g-4">
              {/* STATUS HEADER */}
              <div className="col-12 text-center border-bottom pb-4 mb-2">
                <div className="tiny-text fw-bold text-muted text-uppercase mb-1">Current Status</div>
                <span className={`badge rounded-pill px-4 py-2 fs-6 ${data.reportStatus === "COMPLETE" ? "bg-success" : "bg-warning text-dark"}`}>
                  {data.reportStatus || "In Review"}
                </span>
              </div>

              {/* DETAILS GRID */}
               <div className="col-6">
                <DataField label="Product Code" value={data.productCode} />
              </div>
               <div className="col-6">
                <DataField label="Product Name" value={data.productName} />
              </div>
              <div className="col-6">
                <DataField label="Batch Number" value={data.batchNumber} />
              </div>
              <div className="col-6">
                <DataField label="Batch Size (KGs)" value={data.batchSizeKgs} />
              </div>
              <div className="col-6">
                <DataField label="3rd Party Sampling" value={data.thirdPartySampling ? "Yes" : "No"} />
              </div>
              <div className="col-6">
                <DataField label="Origin" value={data.country} icon="globe" />
              </div>
              <div className="col-6">
                <DataField label="Manufactured" value={data.manufacturingDate} icon="calendar-check" />
              </div>
              <div className="col-6">
                <DataField label="EXPIRY" value={data.expiryDate} icon="calendar-x" />
              </div>
              <div className="col-12">
                <div className="p-3 rounded-3 bg-light border-start border-4 border-success">
                   <DataField label="Classification" value={data.batchType} boldValue />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER INFO */}
        <div className="text-center text-muted small px-4">
          <p className="mb-1">This record is generated automatically by the quality control system.</p>
          <p className="fw-bold">Orgavitaz Quality Assurance © 2026</p>
        </div>

      </div>

      <style>{`
        .fw-extrabold { font-weight: 800; }
        .tiny-text { font-size: 0.7rem; letter-spacing: 1px; }
        .tracking-wider { letter-spacing: 0.05em; }
        .bg-success { background-color: #198754 !important; }
      `}</style>
    </div>
  );
}

function DataField({ label, value, icon, boldValue }) {
  return (
    <div>
      <label className="tiny-text fw-bold text-muted text-uppercase d-block mb-1">{label}</label>
      <div className="d-flex align-items-center">
        {icon && <i className={`bi bi-${icon} me-2 text-success small`}></i>}
        <span className={`${boldValue ? 'fw-bold fs-5' : 'fw-semibold text-dark'}`}>
          {value || "—"}
        </span>
      </div>
    </div>
  );
}